import { useParams, useSearchParams } from 'react-router-dom-v5-compat'
import { useMemo } from 'react'

export const useCSDetailsURLData = () => {
  const { id } = useParams()
  const [searchParams] = useSearchParams()

  const locationId = useMemo(() => searchParams?.get('locationId') || '', [searchParams])
  const accountId = useMemo(() => searchParams?.get('accountId') || '', [searchParams])

  return { id, locationId, accountId }
}
